import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ElementType, IContentElementResultsPrint, QuestionState } from '../models';
import { QuestionPubSub } from '../question-runner/pubsub/question-pubsub';
import { memo } from '../../ui-testrunner/element-render-video/element-render-video.component';
import { DomSanitizer } from '@angular/platform-browser'

const MCQ_OPTION_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

@Component({
  selector: 'element-render-results-print',
  templateUrl: './element-render-results-print.component.html',
  styleUrls: ['./element-render-results-print.component.scss']
})


export class ElementRenderResultsPrintComponent implements OnInit, OnChanges {

  @Input() element:IContentElementResultsPrint;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() questionPubSub?: QuestionPubSub;
  @Input() changeCounter:number;

  imageUrls = new Map();

  // response: string;
  constructor(
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
  }
  isVisible() {
    return this.questionPubSub && this.questionPubSub.isPrintMode;
  }

  isResponseUpload(){
    const responseEntry = this.getResponseEntry();
    if(responseEntry) {
      return responseEntry.type === ElementType.UPLOAD;
    }
  }

  getResponseUrl() {
    const responseEntry = this.getResponseEntry();
    if(responseEntry) {
      return this.getSanitizedUrl(responseEntry.url);
    }
  }

  getSanitizedUrl(url:string){
    return memo(this.imageUrls, url, url => {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    });
  }

  getResponseEntry(){
    if(this.questionState && this.element.inputEntryId && this.questionState[this.element.inputEntryId]) {
      return this.questionState[this.element.inputEntryId];
    }
  }

  getResponseText() {
    const responseEntry = this.getResponseEntry();
    if(responseEntry) {
      switch (responseEntry.type){
        case ElementType.MCQ:
          return this.processMCQ(responseEntry);
        default:
          return responseEntry.str;
      }
    }
  }

  processMCQ(entryData){
    // Note: for MCQ isCorrect is undefined for optional responses
    let responseText: string[] = [];
    if (entryData.selections && entryData.selections.length && entryData.isCorrect !== undefined && !entryData.isOptional) {
      let values;
      values = entryData.selections.map((selection: any) => MCQ_OPTION_MAP[selection.i]).sort();
      responseText.push(values.join(','));
    }
    else {
      responseText.push('');
    }
    return responseText.toString();
  }
}
